import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../decorators';
import { Accuracy2D } from './Accuracy2D';
let Accuracy3D = class Accuracy3D extends Accuracy2D {
  constructor(x, y, z, unit) {
    super(x, y, unit);
    this.value.z = z;
  }
  /**
   * Convert the value to another unit
   * @param {Unit} unit Target unit
   * @returns {Accuracy3D} Converted value
   */
  to(unit) {
    const accuracy = super.to(unit);
    accuracy.z = this.unit.convert(this.z, unit);
    return accuracy;
  }
  valueOf() {
    return (this.x + this.y + this.z) / 3;
  }
  get z() {
    return this.value.z;
  }
  set z(val) {
    this.value.z = val;
  }
};
Accuracy3D = __decorate([SerializableObject(), __metadata("design:paramtypes", [Number, Number, Number, Object])], Accuracy3D);
export { Accuracy3D };